import { api } from '../../lib/api.ts';

export interface House {
  id: string;
  name: string;
  number: number | null;
  ward: string | null;
  address: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface HouseListResult {
  houses: House[];
  total: number;
  page: number;
  pageSize: number;
}

export interface HouseInput {
  name: string;
  number?: number | null;
  ward?: string;
  address?: string;
}

export interface BulkResult {
  created: number;
  skipped: number;
}

export const housesApi = {
  list: (params: { page?: number; pageSize?: number; search?: string } = {}) =>
    api.get<HouseListResult>('/houses', { params }).then((r) => r.data),
  create: (input: HouseInput) =>
    api.post<{ house: House }>('/houses', input).then((r) => r.data.house),
  update: (id: string, input: Partial<HouseInput>) =>
    api.patch<{ house: House }>(`/houses/${id}`, input).then((r) => r.data.house),
  bulk: (houses: HouseInput[]) =>
    api.post<BulkResult>('/houses/bulk', { houses }).then((r) => r.data),
};
